import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-101b7954"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "total-row" }
const _hoisted_2 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", null, [
      _createTextVNode(_toDisplayString(_ctx.$t('cashier.label.total')) + " " + _toDisplayString(_ctx.formatAmount(_ctx.total / _ctx.getCurrencyRate(_ctx.paymentCurrencyId))) + " " + _toDisplayString(_ctx.getCurrencySign(_ctx.paymentCurrencyId)) + " ", 1),
      (_ctx.paymentCurrencyId != _ctx.orderCurrencyId)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, "(" + _toDisplayString(_ctx.formatAmount(_ctx.total / _ctx.getCurrencyRate(_ctx.orderCurrencyId))) + " " + _toDisplayString(_ctx.getCurrencySign(_ctx.orderCurrencyId)) + ")", 1))
        : _createCommentVNode("", true)
    ])
  ]))
}